import React from 'react';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '@mui/material';

export function ContentWithHeading({ heading, children, _className }) {
    const classes = useStyles();
    const getClasses = _className ? `${classes.root} ${_className}` : classes.root
    return <div className={getClasses}>
        {heading && <Typography className={classes.heading}>{heading}</Typography>}
        {children}
    </div>
}
const useStyles = makeStyles(() =>
    createStyles({
        root: {
            // marginBottom: '15px !important'
        },
        heading: {
            marginBottom: '15px !important',
            fontWeight: '600 !important',
            fontSize: '20px !important',
            lineHeight: '24px !important',
        }
    }),
);